import React, { ReactNode } from 'react';

interface FileUploadButtonInterface {
  text?: ReactNode | string;
  onChange: (file: File) => void;
}

export const FileUploadButton = ({ text, onChange }: FileUploadButtonInterface) => {
  const hiddenFileInput = React.useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    hiddenFileInput.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const fileUploaded = e.target.files[0];
      onChange(fileUploaded);
      e.target.value = '';
    }
  };

  return (
    <>
      <div onClick={handleClick} aria-hidden='true'>
        {text ?? 'Upload'}
      </div>
      <input
        type='file'
        ref={hiddenFileInput}
        onChange={(e) => handleChange(e)}
        style={{ display: 'none' }}
        accept='video/*,.jpg,.jpeg,.png' // can replace ".jpg,.jpeg,.png" with "image/*" if we want to allow all image types
      />
    </>
  );
};
